export default "__VITE_ASSET__BsadmfOo__"